import { text as defaultText } from '../../base/defaultText';
import { getTranslation } from '../../base/utils/i18n';
import { config } from '../../config';

const text = {
  ...defaultText,
  'footer.nav.companyName': 'BreakFree Holidays',
  'footer.nav.tagline': `${config['global.brandName']} are registered in England No. 05753643 | Copyright © ${config['global.brandName']}. All rights reserved.`,
  'forms.contactPrefs.thirdOpt':
    "Please tick here if you would like The Sun to keep you informed about exclusive offers, promotions and products from The Sun that we think you'd enjoy such as Sun Savers, Holidays from £9.50 and more. Would you like us to send you these? You can choose to opt out of these at any time.",
  'forms.contactPrefs.emailOpt':
    "Please tick here if you would like The Sun to keep you informed about exclusive travel offers, travel related products and services, news and events. Your information will be used in accordance with The Sun's privacy policy available at newsprivacy.co.uk",
  'header.cs.tel': '0333 220 1901',
  forms: '',
};

/**
 * Fetches a text string from the available text pack
 * @param {string} key - The key of the text string to retrieve
 * @param  {...any} params - Any parameters to pass to your string function. Optional.
 */
export const t = (key, ...params) => getTranslation(key, text, params);
export default t;
